module.exports = {
  appId: 'c1b00902-c9e0-49cf-8a9a-071af454061d',
  scopes: [
    "user.read",
    // "calendars.read"
  ]
};